module.exports = __webpack_public_path__ + "static/media/14.cb0becd1.png";